import React, { useState, useRef, useEffect } from 'react';

function Results({url}) {

    const ref = useRef();
    const [height, setHeight] = useState("0px");
    const resizeIframe = () => {
        setHeight((ref.current.contentWindow.document.body.scrollHeight + 50) + "px");
    };

    useEffect(() => {
        const onResize = () => {
            resizeIframe();
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    return (
        <div>
            <iframe src={url} ref={ref}
                    onLoad={resizeIframe}
                    height={height}
                    frameborder="0" style={{overflow:'hidden', width: '100%'}} ></iframe>
        </div>
    );
}


export default Results;